/* istanbul ignore next */
import Quasar, {
  GoBack,
  QBtn,
  QCard,
  QCardActions,
  QCardMain,
  QCardMedia,
  QPullToRefresh,
  QCardSeparator,
  QCardTitle,
  QChip,
  QDatetime,
  QField,
  QInput,
  QItem,
  QItemMain,
  QItemSeparator,
  QItemSide,
  QItemTile,
  QLayout,
  QLayoutDrawer,
  QLayoutHeader,
  QList,
  QListHeader,
  QModal,
  QModalLayout,
  QPage,
  QPageContainer,
  QSelect,
  QStep,
  QStepper,
  QStepperNavigation,
  QToolbar,
  QToolbarTitle,
} from 'quasar';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueTouch from 'vue-touch';
import * as VueGoogleMaps from 'vue2-google-maps';
import vSelect from 'vue-select';
import { show404, isDev, getEnv } from 'Lib/utils';
import Datetime from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import Auth from 'Lib/auth';
import eventBus from 'Lib/eventBus';
import menuEvents from 'Lib/mixins/menuEvents';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VeeValidate from 'vee-validate';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VChip,
  VCard,
  VSwitch,
  VAutocomplete,
  VDatePicker,
  VDialog,
  VSnackbar,
  VDivider,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VImg,
  VOverflowBtn,
  VGrid,
  VTabs,
  VBadge,
  VProgressCircular,
  VProgressLinear,
  VDataTable,
  VSelect,
  VAlert,
  VDataIterator,
  VToolbar,
  VTextarea,
  VMenu,
  VBreadcrumbs,
  VRadioGroup,
  VTextField,
  VSpeedDial,
  VTooltip,
  VCheckbox,
  VSubheader,
  VExpansionPanel,
  VInput,
  VBottomSheet,
  transitions,
  VBtnToggle,
} from 'vuetify';
import 'vuetify/src/stylus/app.styl';


const chartComponentNames = [
  'AlertLevel',
  'Area',
  'Bar',
  'FourBar',
  'Line',
  'LineBar',
  'Gantt',
  'HighLowAvg',
  'StackedBar',
  'StackedLine',
];

function loadPlugins() {
  Vue.use(Vuelidate);

  Vue.use(VueTouch, { name: 'v-touch' });

  Vue.component('VueSlider', VueSlider);

  /* istanbul ignore next */
  Vue.use(VueGoogleMaps, {
    load: {
      key: getEnv('GOOGLE_MAP_KEY') || '',
      libraries: 'places',
    },
  });

  /* istanbul ignore next */
  Vue.use(Quasar, {
    components: {
      QBtn,
      QCard,
      QCardTitle,
      QCardMain,
      QCardMedia,
      QCardSeparator,
      QPullToRefresh,
      QCardActions,
      QChip,
      QDatetime,
      QField,
      QInput,
      QItemSeparator,
      QItem,
      QItemSide,
      QItemMain,
      QItemTile,
      QLayout,
      QLayoutHeader,
      QLayoutDrawer,
      QList,
      QListHeader,
      QModal,
      QModalLayout,
      QPage,
      QPageContainer,
      QSelect,
      QStepper,
      QStep,
      QStepperNavigation,
      QToolbar,
      QToolbarTitle,
    },
    directives: {
      GoBack,
    },
    plugins: {},
  });

  Vue.use(Vuetify, {
    components: {
      VApp,
      VNavigationDrawer,
      VSwitch,
      VAutocomplete,
      VFooter,
      VCard,
      VChip,
      VDatePicker,
      VDialog,
      VDivider,
      VList,
      VBtn,
      VIcon,
      VGrid,
      VRadioGroup,
      VImg,
      VProgressCircular,
      VProgressLinear,
      VSnackbar,
      VSelect,
      VTextarea,
      VDataIterator,
      VInput,
      VTextField,
      VToolbar,
      VAlert,
      VTabs,
      VBadge,
      VDataTable,
      VCheckbox,
      VBreadcrumbs,
      VOverflowBtn,
      VSubheader,
      VMenu,
      VSpeedDial,
      VTooltip,
      VExpansionPanel,
      VBottomSheet,
      transitions,
      VBtnToggle,
    },
    theme: {
      primary: '#00cb80',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#2E7D32',
      warning: '#FFC107',
    },
  });

  Vue.component('v-select2', vSelect);

  Vue.component('vue-phone-number-input', VuePhoneNumberInput);

  Vue.use(VeeValidate, {
    fieldsBagName: 'vvFields',
  });

  Vue.use(Datetime);

  chartComponentNames.forEach((chart) => {
    Vue.component(`${chart}Chart`, () => import(`Components/charts/${chart}Chart`));
  });

  Vue.mixin(menuEvents);

  if (!isDev()) {
    Raven
      .config('https://64a60199f6844942a8e8a3c20915f95d@sentry.io/1359010', {
        environment: process.env.NODE_ENV,
        autoBreadcrumbs: {
          xhr: false, // XMLHttpRequest
          console: false, // console logging
          dom: true, // DOM interactions, i.e. clicks/typing
          location: true, // url changes, including pushState/popState
          sentry: true, // sentry events
        },
        debug: true,
      })
      .addPlugin(RavenVue, Vue)
      .install();
  }
}

function loadGlobals() {
  Object.assign(Vue.config, {
    productionTip: process.env.NODE_ENV === 'production',
  });

  Object.assign(Vue.prototype, {
    $eventBus: eventBus,
    $404: show404,
    $auth: Auth,
  });
}

loadPlugins();
loadGlobals();

/* Externals */

/**
 * Vue
 * @external Vue
 * @description Vue.JS Library Instance
 * @see {@link https://vuejs.org/v2/api/|Vue}
 */

/**
 * Vuex
 * @external Vuex
 * @description Vuex Library Instance
 * @see {@link https://vuex.vuejs.org/api/|Vuex}
 */

/**
 * VueApollo
 * @external VueApollo
 * @method mutate
 * @description Vue-Apollo Package Instance
 * @see {@link https://github.com/Akryum/vue-apollo/blob/master/types/vue-apollo.d.ts#L18|VueApollo}
 */

/* Types */

/**
 * ChartType used in Chart.JS library
 * @typedef ChartType
 * @property {string} bar-chart [Bar](https://www.chartjs.org/docs/latest/charts/bar.html)
 * @property {string} horizontalbar-chart [Horizontal Bar](https://www.chartjs.org/docs/latest/charts/bar.html)
 * @property {string} doughnut-chart [Doughnut](https://www.chartjs.org/docs/latest/charts/doughnut.html)
 * @property {string} line-chart [Line](https://www.chartjs.org/docs/latest/charts/line.html)
 * @property {string} pie-chart [Pie](https://www.chartjs.org/docs/latest/charts/doughnut.html)
 * @property {string} polar-chart [Pie](https://www.chartjs.org/docs/latest/charts/polar.html)
 * @property {string} radar-chart [Radar](https://www.chartjs.org/docs/latest/charts/polar.html)
 * @property {string} bubble-chart [Bubble](https://www.chartjs.org/docs/latest/charts/bubble.html)
 */

/**
 * Registry Entry Type
 * @namespace RegistryEntryType
 * @typedef {RegistryEntryType} Registry Navigator entry
 * @property {String} name - Entry name
 * @property {String|null} parentKey - Parent key
 * @property {RegistryEntryTypes.Record|RegistryEntryTypes.Directory} type - Entry type
 */

/**
 * Registry attachTo Type
 * @namespace RegistryAttachToType
 * @typedef {RegistryAttachToType} Registry Navigator parent
 * @property {String} name - Entry name
 * @property {String} _id - ID. Valid format: 'Name/Number'. Example: 'Assets/12345'
 */


/**
 * GraphQLDocument Type
 * @namespace GraphQLDocument
 * @typedef {GraphQLDocument} GraphQLDocument type
 * @property {Array} definitions - Document definitions
 */
